const {Vector3} = THREE;
import {transformPoint, getCentroid, getWorldPosition, setQuaternionFromDirection} from './utils.js';

const Z_AXIS = new Vector3(0, 0, 1);
const {DEG2RAD, RAD2DEG} = THREE.MathUtils;

/**
 * A class for a constraint.
 */
class IKSliderConstraint {
    /**
     * Pass in an angle value in degrees.
     *
     * @param {number} length
     * @param {Vector3} slideAxis
     */
    constructor(length, slideAxis) {
        this.isSlider = true;
        this.length = length;
        this.slideAxis = slideAxis.clone().normalize();
    }

    /**
     * Applies a constraint to passed in IKJoint, updating
     * its direction if necessary. Returns a boolean indicating
     * if the constraint was applied or not.
     *
     * @param {IKJoint} joint
     * @private
     * @return {boolean}
     */
    _apply(joint) {

        if (joint.disabled) {
            return false;
        }

        // Get direction of joint and parent in world space
        const direction = new Vector3().copy(joint._getDirection());
        const parentDirection = joint._localToWorldDirection(new Vector3().copy(this.slideAxis)).normalize();

        // Find the current angle between them
        const currentAngle = direction.angleTo(parentDirection) * RAD2DEG;

        if (0 < currentAngle) {
            direction.normalize();
            // Find the correction axis and rotate around that point to the
            // largest allowed angle
            const correctionAxis = new Vector3().crossVectors(parentDirection, direction).normalize();

            parentDirection.applyAxisAngle(correctionAxis, 0);
            joint._setDirection(parentDirection);
            return true;
        }

        return false;
    }
}

export default IKSliderConstraint;
